/**
 * Bank Account Service
 * Handles all bank account management API calls
 */

import { apiGet, apiPost, apiPut } from './apiClient';
import API_CONFIG from './apiConfig';

/**
 * Add a new bank account
 * @param {Object} data - { bankName: string, accountNumber: string, accountHolderName: string, routingNumber?: string, swiftCode?: string, address?: string }
 * @returns {Promise}
 */
export const addBankAccount = async (data) => {
  return apiPost(API_CONFIG.endpoints.bankAccounts, data);
};

/**
 * Get all user's bank accounts
 * @returns {Promise}
 */
export const getBankAccounts = async () => {
  return apiGet(API_CONFIG.endpoints.bankAccounts);
};

/**
 * Update a bank account
 * @param {string} accountId - Bank account ID
 * @param {Object} data - { bankName?: string, accountNumber?: string, accountHolderName?: string, ... }
 * @returns {Promise}
 */
export const updateBankAccount = async (accountId, data) => {
  return apiPut(API_CONFIG.endpoints.bankAccountById(accountId), data);
};

